import { Component, OnInit, Inject } from '@angular/core';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Voucher } from 'src/app/models/voucher';
import { VoucherService } from 'src/app/services/voucher.service';
import { SegmentacaoService } from 'src/app/services/segmentacao.service';
import { Segmentacao } from 'src/app/models/segmentacao';
import { PerfilService } from 'src/app/services/perfil.service';

@Component({
  selector: 'app-cadastrar-voucher-modal',
  templateUrl: './cadastrar-voucher-modal.component.html',
  styleUrls: ['./cadastrar-voucher-modal.component.scss']
})
export class CadastrarVoucherModalComponent implements OnInit {
  voucher: Voucher;

  idVoucher: number;
  idCliente: number;

  tiposDesconto = [
    { id: 0, nome: '% sobre o pedido' },
    { id: 1, nome: 'R$ sobre o pedido' },
  ];

  classificacoes: Segmentacao[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  perfisDeAcesso = [];

  constructor(
    private dialogRef: MatDialogRef<CadastrarVoucherModalComponent>,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private voucherService: VoucherService,
    private perfilService: PerfilService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if(this.data) {
      this.idCliente = this.data.idCliente;
      if(!this.data.voucher) {
        this.voucher = new Voucher();
        this.voucher.perfis = [];
      }
    }
  }

  ngOnInit(): void {
    this.buscarPerfisDeAcesso();
  }

  buscarPerfisDeAcesso() {
    this.carregandoService.mostra('buscarPerfisDeAcesso');

    this.perfilService.consultarPerfis().subscribe(
      (perfisDeAcesso) => {
        this.perfisDeAcesso = perfisDeAcesso;

        this.carregandoService.esconde('buscarPerfisDeAcesso');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPerfisDeAcesso');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarVoucher() {
    this.carregandoService.mostra('buscarVoucher');
    this.voucherService.consultarPorId(this.idVoucher).subscribe(
      voucher => {
        this.voucher = voucher;
        this.carregandoService.esconde('buscarVoucher');
      },
      err => {
        this.carregandoService.esconde('buscarVoucher');
        this.notificacaoService.erro(err);
      }
    );
  }

  salvar() {
    this.carregandoService.mostra('salvar');

    this.voucher.idCliente = this.idCliente;
    this.voucher.valorMinimoPedido = Number(this.voucher.valorMinimoPedido);
    this.voucher.valor = Number(this.voucher.valor);

    this.voucherService.salvar(this.voucher).subscribe(
      () => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.sucesso('Voucher salvo com sucesso!!!');
        this.dialogRef.close(this.voucher);
      },
      err => {
        this.carregandoService.esconde('salvar');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }
}
